/**
 * Per-org storage quota editor dialog (super_admin only).
 *
 * Extracted verbatim from StorageFilesTab.jsx during the Phase 6 refactor
 * (no behaviour change).
 */
import { useState } from 'react';
import { Settings, Loader2 } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '../../../components/ui/dialog';
import { formatBytes } from '../../../utils/uploadImage';

export function QuotaEditor({ row, onSave }) {
  const [open, setOpen] = useState(false);
  const [gb, setGb] = useState(row.quota_bytes != null ? (row.quota_bytes / 1024 ** 3).toFixed(1) : '');
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await onSave(gb === '' ? null : parseFloat(gb));
      setOpen(false);
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Button size="sm" variant="ghost" onClick={() => setOpen(true)} data-testid={`quota-edit-${row.org_id}`} title="Edit quota">
        <Settings className="w-4 h-4" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Storage quota — {row.org_name}</DialogTitle>
          </DialogHeader>
          <div className="space-y-3 py-2">
            <Label>Quota (GB) — leave blank for unlimited</Label>
            <Input type="number" min="0" step="0.5" value={gb} onChange={e => setGb(e.target.value)} placeholder="Unlimited" data-testid="quota-gb-input" />
            <p className="text-xs text-muted-foreground">Currently using: {formatBytes(row.total_bytes)}</p>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} disabled={saving}>Cancel</Button>
            <Button onClick={handleSave} disabled={saving} data-testid="quota-save-btn">
              {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
              Save
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
